import { ErrorMessage } from '@hookform/error-message';

/**
 * A wrapper for PrimeReact form errors.
 * Note: does not handle multiple messages currently
 *
 * @param props Similar to ErrorMessage props
 * @returns Component with prime react form error label
 */
export default function ErrorLabel(props: {
  errors: any;
  name: string;
  message?: string | undefined;
}) {
  const { errors, name, message } = props;

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      message={message}
      render={({ message, messages }) => {
        if (!message && !messages) {
          // Regex to split up camel case into separate words roughly as a fallback
          return (
            <small className="p-error capitalize">
              {errors?.[name]?.type?.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}
            </small>
          );
        }
        return <small className="p-error">{message}</small>;
      }}
    />
  );
}
